import { createRoutes } from 'shared/hocs'

import { TeamsOverview } from './overview'
import { TeamsAdd } from './overview/components/add'
import { TeamsUpdate } from './overview/components/update/container'

export const Teams = createRoutes(({ match }) => [
  {
    exact: true,
    path: `${match.path}/edit`,
    component: TeamsAdd,
  },
  {
    path: `${match.path}/edit/:teamId`,
    component: TeamsUpdate,
  },
  {
    exact: true,
    path: match.path,
    component: TeamsOverview,
  },
])
